import { useContext } from "react";
import { I18nContext } from "../contexts/I18nContext";

function useTranslations() {
  return useContext(I18nContext);
}

export default useTranslations;
